import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  orderNumberHeader: {
    id: 'X9aZcn',
    defaultMessage: 'TO: #{orderId}',
    description: 'Header title for transfer order page',
  },
  actionsDropdown: {
    id: 'pCdzgj',
    defaultMessage: 'Actions',
    description: 'Actions dropdown button label',
  },
  editAction: {
    id: '2LgZoR',
    defaultMessage: 'Edit',
    description: 'Edit action in the actions dropdown for transfer order',
  },
  save: {
    id: 'bIoQi/',
    defaultMessage: 'Save',
    description: 'Save button label in transfer order edit mode',
  },
  cancel: {
    id: 'Zv5erQ',
    defaultMessage: 'Cancel',
    description: 'Cancel button label in transfer order edit mode',
  },
  confirmCancelHeader: {
    id: 'KLnPMz',
    defaultMessage: 'Unsaved changes',
    description: 'Header for confirm cancel modal in transfer order edit mode',
  },
  confirmCancelBody: {
    id: '5L3+Gk',
    defaultMessage: 'You have unsaved changes. Are you sure you want to discard them?',
    description: 'Body for confirm cancel modal in transfer order edit mode',
  },
  confirmDiscardButton: {
    id: 'aO/Azi',
    defaultMessage: 'Discard changes',
    description: 'Confirm discard button in transfer order edit mode cancel modal',
  },
  receiveStock: {
    id: 'wlCEGH',
    defaultMessage: 'Receive Stock',
    description: 'Receive stock button label',
  },
  actionsCancelOrder: {
    id: 'VeEzm+',
    defaultMessage: 'Cancel Order',
    description: 'Cancel order action in dropdown menu',
  },
  cancelSuccessMessage: {
    id: 'xVx3PL',
    defaultMessage: 'Transfer order cancelled successfully',
    description: 'Success message after cancelling transfer order',
  },
  cancelErrorMessage: {
    id: 'IY7ZdO',
    defaultMessage: 'Failed to cancel transfer order',
    description: 'Error message when cancelling transfer order fails',
  },
  actionsCloseOrder: {
    id: 'o0zV50',
    defaultMessage: 'Close Order',
    description: 'Close order button label',
  },
  closeSuccessMessage: {
    id: 'WQ/J+G',
    defaultMessage: 'Transfer order closed successfully',
    description: 'Success message after closing transfer order',
  },
  closeErrorMessage: {
    id: '5DjpeY',
    defaultMessage: 'Failed to close transfer order',
    description: 'Error message when closing transfer order fails',
  },
  confirmCloseHeader: {
    id: 'DKajxr',
    defaultMessage: 'Close Transfer Order',
    description: 'Header for close transfer order confirmation modal',
  },
  confirmCloseBody: {
    id: 'C2f20n',
    defaultMessage: 'Are you sure you want to close transfer order #{orderNumber}? This action cannot be undone.',
    description: 'Body for close transfer order confirmation modal',
  },
  confirmCloseButton: {
    id: 'FTdEPB',
    defaultMessage: 'Confirm',
    description: 'Confirm close button in transfer order close modal',
  },
});
